export default __webpack_public_path__ + "static/media/content_04_bg.42ae936f.jpg";